import { useEnv } from '@praxis/component-runtime-env'

export function withEnv(Component) {
    return function WrappedComponent(props) {
      const env = useEnv();
      return <Component {...props} env={env} />;
    }
  }